const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/discovery/api-factory');
const serviceFactory = require('../resources/discovery/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`
  });
  
  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}discovery.history`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getDiscoveryHistory(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        
      )))

      .match(`${p}discovery.new[{keys:discoItem}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.addDiscoveryHistory(req.params)
            .then(response => res.value(response))
            .catch(res.error)
          
        )))

   

  }

module.exports = addRoutes;
